import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectSecretGeneric } from '@shared/index';
import { removeFromArray } from '@reflact/tsutil';
import { firstValueFrom } from 'rxjs';

export type ProjectSecret = ProjectSecretGeneric


@Injectable({
  providedIn: 'root'
})
export class ProjectSecretService {

  private _apiReadUrl = "/api/admin/project/secret/read";
  private _apiWriteUrl = "/api/admin/project/secret/write";

  public projectSecrets: ProjectSecret[] = [];
  private _selectedProjectId: string = "";

  constructor(private http: HttpClient) {
  }

  public get selectedProjectId(): string {
    return this._selectedProjectId;
  }

  public set selectedProjectId(p: string) {
    if (this._selectedProjectId == p) { return; }
    this._selectedProjectId = p;
    void this.selectedProjectChanged();
  }

  private async selectedProjectChanged() {
    if (this.selectedProjectId == "") {
      this.projectSecrets = [];
      return;
    }
    this.projectSecrets = await this.getSecrets();

  }

  private async getSecrets() {
    const result = await firstValueFrom(this.http.get<ProjectSecret[]>(`${this._apiReadUrl}/${this.selectedProjectId}/list`));
    return result;
  }

  public async createSecret(name: string, description: string, secret: string) {
    const result = await firstValueFrom(this.http.post<ProjectSecret>(`${this._apiWriteUrl}/${this.selectedProjectId}/add`,
      {
        name,
        description,
        secret
      }
    ));
    this.projectSecrets.unshift(result);
    return result;
  }

  public async updateSecret(secretId: string, name: string, description: string, secret?: string) {
    const result = await firstValueFrom(this.http.post<ProjectSecret>(`${this._apiWriteUrl}/${this.selectedProjectId}/update`,
      {
        secretId,
        name,
        description,
        secret
      }
    ));
    if (result.projectId == this.selectedProjectId) {
      const index = this.projectSecrets.findIndex(ps => ps._id == result._id);
      if (index >= 0) {
        this.projectSecrets[index] = result;
      }
    }
    return result;
  }

  public async deleteSecret(secretId: string) {
    const result = await firstValueFrom(this.http.post<{ msg: string, projectId: string, secretId: string }>(`${this._apiWriteUrl}/${this.selectedProjectId}/remove`,
      { secretId }
    ));
    if (result.projectId == this.selectedProjectId) {
      removeFromArray(this.projectSecrets, (ps) => ps._id == result.secretId);
    }
    return result;
  }

}
